<template>
  <div>
    <header-component
      :is-soon="true"
      :backRoute="false"
      img-left="/trocachip/img/default_white.png"
      img-right="/trocachip/img/access-white.svg"
      v-if="!logoMobile"
    />
    <header-component
      :is-soon="true"
      :backRoute="false"
      img-left="/trocachip/img/default_white.png"
      img-right="/trocachip/img/access-white.svg"
      v-if="logoMobile"
    />
    <div class="welcome" :class="{ 'ac-bg-black': ac }">
      <div class="scrollable_text">
        <!--ICON CHECKMARK-->
        <div class="activate_icon-success" v-if="!showQROnTop()">
          <img src="../assets/images/ic-check.svg" v-if="!ac" />
          <img src="../assets/images/ic-check-ac.svg" v-if="ac" />
        </div>
        <!--TITLE-->
        <h2
          class="activate_title"
          :class="{ 'ac-color-yellow': ac, shortActivateTitle: showQROnTop() }"
          v-html="installPageMessages.title"
        ></h2>
        <p class="activate_info" v-html="installPageMessages.info"></p>
        <p class="activate_subinfo" v-html="installPageMessages.subinfo"></p>
        <!--PROTOCOL-->
        <span
          id="protocol"
          class="activate_protocol"
          v-bind:class="{ shortProtocol: showQROnTop() }"
        >
          {{ installPageMessages.protocolLabel }} {{ protocol }}
        </span>
        <!--QR CODE ON TOP-->
        <div class="toggle_div" v-if="showQROnTop()">
          <p
            class="activate_info"
            v-html="installPageMessages.stepZeroTitle"
          ></p>
          <p
            class="activate_info"
            v-html="installPageMessages.stepThreeCopy"
          ></p>
          <vue-qrcode
            :margin="2"
            :value="urlEsim"
            class="esim_qr_code"
            v-bind:class="{ shortQR: showQROnTop() }"
          />
          <div
            class="esim_url_container"
            v-bind:class="{ shortContainer: showQROnTop() }"
            v-if="systemSelected == systemsListToActive.iosSystem"
          >
            <span class="esim_url" v-html="correctValue(2)"></span>
            <button
              class="copy_button"
              v-bind:class="{ shortCopyButton: showQROnTop() }"
              v-clipboard:copy="correctValue(2)"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <img src="../assets/images/copy-icon.svg" />
            </button>
          </div>
          <div
            class="esim_url_container"
            v-bind:class="{ shortContainer: showQROnTop() }"
            v-if="
              systemSelected == systemsListToActive.samsungSystem ||
              systemSelected == systemsListToActive.motorolaSystem
            "
          >
            <span class="esim_url" v-html="urlEsim"></span>
            <button
              class="copy_button"
              v-bind:class="{ shortCopyButton: showQROnTop() }"
              v-clipboard:copy="urlEsim"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <img src="../assets/images/copy-icon.svg" />
            </button>
          </div>
          <p
            class="activate_info"
            v-if="systemSelected == systemsListToActive.iosSystem"
          >
            Endereço SM-DP+
          </p>
          <div
            class="esim_url_container"
            v-bind:class="{ shortContainer: showQROnTop() }"
            v-if="systemSelected == systemsListToActive.iosSystem"
          >
            <span class="esim_url" v-html="correctValue(1)"></span>
            <button
              class="copy_button"
              v-bind:class="{ shortCopyButton: showQROnTop() }"
              v-clipboard:copy="correctValue(1)"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              @click="() => onCopy()"
            >
              <img src="../assets/images/copy-icon.svg" />
            </button>
          </div>

          <hr class="section_separator_line" />
          <div class="passo_a_passo">Confira um passo a passo detalhado:</div>
        </div>
        <!--STEP 1-->
        <img class="step_image" src="img/validation-carousel/passo1de4.svg" />
        <p class="activate_info" v-html="installPageMessages.stepOneTitle"></p>
        <hr class="section_separator_line" />
        <!--STEP 2-->
        <img class="step_image" src="img/validation-carousel/passo2de4.svg" />
        <p class="activate_info" v-html="installPageMessages.stepTwoTitle"></p>
        <div class="selection_container">
          <div class="selection_input" @click="toggleSystemSelectionOpened">
            <span
              v-html="
                systemSelected
                  ? systemSelected
                  : 'Selecione o sistema do seu aparelho'
              "
            />
          </div>
          <div
            class="selection_options_container"
            :class="{ opened_options: systemSelectionOpened }"
          >
            <label
              id="device_mark"
              class="options_label"
              v-for="(item, index) in systemsListToActive"
              :key="index"
              v-html="item"
              :value="item"
              @click="() => selectSystem(item)"
            />
          </div>
        </div>
        <hr class="section_separator_line" />
        <!--STEP 3-->
        <img class="step_image" src="img/validation-carousel/passo3de4.svg" />
        <p
          class="activate_info"
          v-html="installPageMessages.stepThreeTitle"
        ></p>
        <p
          class="activate_info"
          v-html="installPageMessages.stepThreeSubTitle"
        ></p>
        <p class="activate_info" v-html="installPageMessages.stepThreeCopy"></p>
        <vue-qrcode :margin="2" :value="urlEsim" class="esim_qr_code" />
        <div
          class="esim_url_container"
          v-if="systemSelected == systemsListToActive.iosSystem"
        >
          <span class="esim_url" v-html="correctValue(2)"></span>
          <button
            class="copy_button"
            v-clipboard:copy="correctValue(2)"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
        <div
          class="esim_url_container"
          v-if="
            systemSelected == systemsListToActive.samsungSystem ||
            systemSelected == systemsListToActive.motorolaSystem
          "
        >
          <span class="esim_url" v-html="urlEsim"></span>
          <button
            class="copy_button"
            v-clipboard:copy="urlEsim"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
        <p
          class="activate_info"
          v-if="systemSelected == systemsListToActive.iosSystem"
        >
          Endereço SM-DP+
        </p>
        <div
          class="esim_url_container"
          v-if="systemSelected == systemsListToActive.iosSystem"
        >
          <span class="esim_url" v-html="correctValue(1)"></span>
          <button
            class="copy_button"
            v-clipboard:copy="correctValue(1)"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            @click="() => onCopy()"
          >
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>

        <hr class="section_separator_line" />
        <!--STEP 4-->
        <img class="step_image" src="img/validation-carousel/passo4de4.svg" />
        <p class="activate_info" v-html="installPageMessages.stepFourTitle"></p>
        <hr class="section_separator_line" />
        <div class="button_container">
          <button
            class="instalation_instructions_button"
            @click="goToInstallationGuide"
          >
            {{ installPageMessages.buttonText }}
          </button>
        </div>
        <toast v-if="toast.open" @closetoast="closeToast"></toast>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderComponent from "@/components/HeaderComponent";
import VueQrcode from "vue-qrcode";
import Toast from "../components/Toast.vue";
import trackEvent from "../services/trackEvent";

export default {
  name: "install_esim",
  components: {
    HeaderComponent,
    VueQrcode,
    Toast,
  },
  data() {
    return {
      title: "",
      description: "",
      titleProgress: "",
      steps: [],
      infoModal: false,
      alertError: false,
      systemsListToActive: "",
      systemSelected: "Samsung Android 10.0 ou superior",
      systemSelectionOpened: false,
      toast: {
        open: false,
      },
    };
  },
  created() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };

    this.sendTracker("troca esim", 7, 3);
    this.systemsListToActive = this.systemsToActive;
    console.log("THE SELECTED BRAND WAS " + this.selectedBrand);
    if (this.selectedBrand === "Apple") {
      console.log("THE SELECTED BRAND WAS " + this.selectedBrand);
      this.selectSystem("Iphone IOS 13.3.1 ou posterior");
    }
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      protocol: (state) => state.protocol,
      installPageMessages: (state) => state.config.installEsimPageMessages,
      urlEsim: (state) => state.urlEsim,
      systemsToActive: (state) => state.config.systemsToActive,
      toggleQROnTop: (state) => state.config.toggleQROnTop,
      selectedBrand: (state) => state.selectedBrand,
      customer: (state) => state.customer,
    }),
    logoMobile: function () {
      return window.innerWidth < 768;
    },
  },
  methods: {
    selectSystem(value) {
      this.systemSelected = value;
      this.systemSelectionOpened = false;
    },
    toggleSystemSelectionOpened() {
      this.systemSelectionOpened = !this.systemSelectionOpened;
    },
    correctValue(value) {
      const str = this.urlEsim;
      const urlEsim = str.split("$");
      return urlEsim[value];
    },
    onError() {
      console.log("Erro ao copiar código");
    },
    onCopy() {
      if (this.toast) {
        this.toast.open = true;
        console.log("Código copiado com sucesso!");
      } else {
        console.error("O componente Toast não foi encontrado.");
      }
    },
    closeToast() {
      this.toast.open = false;
    },
    goToInstallationGuide() {
      this.sendTracker("como instalar");
      this.$router.push({ name: "installation-guide" });
    },
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.isExOi() ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    showQROnTop() {
      return this.toggleQROnTop && this.selectedBrand === "Apple";
    },
    isExOi() {
      if (this.config["init_flow"] === undefined) {
        this.alertError = true;
      }

      return JSON.parse(this.customer.isExOiCustomer);
    },
  },
};
</script>
<style lang="scss" scoped>
#welcome_container {
  padding-bottom: 32px;
}

.welcome {
  width: 100%;
  height: 100vh;
  z-index: -1000;
  background-color: #003091;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #ccc;
  padding: 10px;
}

.scrollable_text {
  overflow-y: scroll;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.activate_icon-success {
  width: 61px;
  height: 61px;
  margin: 63px auto 0 auto;
  position: relative;
  display: block;
}

.activate_title {
  width: 292px;
  height: auto;
  display: block;
  position: relative;
  font-family: "timsans_regular";
  margin: 40px auto 0 auto;
  font-size: 1.688em;
  font-weight: 300;
  line-height: 1.11;
  text-align: center;
  color: #ffffff;
}

.activate_info {
  width: 85vw;
  height: auto;
  display: block;
  position: relative;
  margin: 16px auto 0 auto;
  font-family: "timsans_regular";
  font-size: 14px;
  line-height: 1.33;
  letter-spacing: -0.3px;
  text-align: center;
  color: #ffffff;
}

.activate_subinfo {
  width: 85vw;
  height: auto;
  display: block;
  position: relative;
  margin: 16px auto 0 auto;
  font-family: "timsans_regular";
  font-size: 0.75em;
  line-height: 1.33;
  letter-spacing: -0.3px;
  text-align: center;
  color: #ffffff;
}

.activate_protocol {
  width: 147px;
  height: auto;
  display: block;
  position: relative;
  margin: 16px auto 40px auto;
  font-family: "timsans_regular";
  font-size: 0.75em;
  line-height: 2;
  text-align: center;
  color: #ffffff;
}

.passo_a_passo {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 10px;
  font-family: "timsans_regular";
  font-size: 1rem;
  color: #fff;
}

.step_image {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
}

.section_separator_line {
  width: 85vw;
  height: 1px;
  background-color: #d9d9d9;
  margin: 26px auto 32px auto;
  opacity: 0.5;
}

.selection_container {
  position: relative;
}

.selection_input {
  width: 85vw;
  height: 52px;
  padding: 0px 24px;
  border-radius: 26px;
  color: #000;
  margin: 1rem auto 1.5rem auto;
  font-family: "timsans_regular";
  font-size: 1rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  overflow-x: auto;
  border: 1px solid #b3b3b3;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: #ffffff;
}

.selection_input::after {
  content: "<";
  font: 20px "Consolas", monospace;
  color: #9c9c9c;
  -webkit-transform: rotate(180deg) scaleY(1.2);
  -moz-transform: rotate(270deg) scaleY(1.2);
  -ms-transform: rotate(270deg) scaleY(1.2);
  transform: rotate(270deg) scaleY(1.2);
  right: 40px;
  position: absolute;
  pointer-events: none;
}

.selection_options_container {
  display: none;
}

.esim_qr_code {
  border-radius: 8px;
  margin: 22px auto 0 auto;
  width: 148px;
  height: 148px;
}

.esim_url_container {
  padding-left: 14px;
  text-overflow: ellipsis;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  background-color: #fff;
  border: 1px dashed #bababa;
  border-radius: 12px;
  width: 85vw;
  margin: 1rem auto 0 auto;
}

.esim_url {
  white-space: nowrap;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow-x: hidden;
  font-family: "timsans_regular";
  color: #000;
  padding-right: 5px;
}

.copy_button {
  height: 50px;
  background: transparent;
  cursor: pointer;
  padding: 0px 14px;
  border-left: 1px dashed #bababa;
  border-right: none;
  border-top: none;
  border-bottom: none;
}

.opened_options {
  position: absolute;
  display: flex;
  width: 100%;
  max-height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.options_label {
  width: 85vw;
  padding: 24px 0 0 24px;
  font-family: "timsans_regular";
  font-size: 0.875rem;
  color: #9c9c9c;
  line-height: 21px;
  cursor: pointer;
}

.instalation_instructions_button {
  width: 85vw;
  height: 52px;
  border: 1px solid #fff;
  border-radius: 26px;
  color: #fff;
  background-color: transparent;
  margin: 26px;
  font-family: "timsans_regular";
}

.button_container {
  height: 104px;
}

.toggle_div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.shortProtocol {
  margin: 8px auto 0px auto !important;
}

.shortQR {
  margin-top: 12px !important;
}

.shortContainer {
  height: 40px !important;
}

.shortActivateTitle {
  margin: 80px auto 0 auto !important;
  font-size: 1.2em;
}

.shortCopyButton {
  height: 40px !important;
}
</style>